// extracted by mini-css-extract-plugin
export default {"root":"FieldProvinciasSelect_root__BGG3i","label":"FieldProvinciasSelect_label__kPQXP label","error":"FieldProvinciasSelect_error__JISoj h5"};